/**
 * StatTiles.tsx — a responsive row of labelled count tiles for the analytics
 * surfaces (2026-07-21). Pure presentation: it renders whatever { label, value }
 * pairs it is given. Colours come from CSS variables (dark-mode-safe). Values
 * are plain counts here — the money earnings table renders its own £ tiles on
 * the ADMIN surface, never through this component.
 */

export interface Stat {
  label: string;
  value: number | string;
  /** Optional sub-label (e.g. "last 30 days"). */
  hint?: string;
}

export function StatTiles({ items }: { items: Stat[] }) {
  return (
    <div
      role="list"
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(9rem, 1fr))',
        gap: 'var(--gps-s-2)',
      }}
    >
      {items.map((s) => (
        <div
          key={s.label}
          role="listitem"
          style={{
            padding: 'var(--gps-s-3)',
            borderRadius: 'var(--gps-r-md)',
            border: '1px solid var(--gps-border)',
            background: 'var(--gps-surface)',
          }}
        >
          <div style={{ fontSize: '13px', color: 'var(--gps-muted)', fontWeight: 600 }}>{s.label}</div>
          <div style={{ fontSize: '26px', fontWeight: 700, color: 'var(--gps-text)', fontVariantNumeric: 'tabular-nums' }}>
            {s.value}
          </div>
          {s.hint ? <div style={{ fontSize: '12px', color: 'var(--gps-muted)' }}>{s.hint}</div> : null}
        </div>
      ))}
    </div>
  );
}
